import {domReady} from './Functions/DomReady';
import * as Sentry from '@sentry/browser';
import {detectBrowser} from './Functions/BrowserDetection';
import {mailDecryption} from './Functions/MailDecryption';
import {Modal} from './Modal/Modal';
import 'es6-promise/auto';
import 'whatwg-fetch';
import {injectTagManager} from './Utility/GoogleTagManagerUtility';
import {MultiSelect} from './Choices/Choices';
import {FilterJobsController} from './Functions/FilterJobs';
import {FormValidator} from './Form/FormValidator';
import {FormController} from './Form/FormController';
import {CookieBar} from './CookieBar/CookieBar';
import {SearchSuggest} from './Search/SearchSuggest';
import {SearchResultPage} from './Search/SearchResultPage';
import {LoginController} from './User/Login';
import {RegisterController} from './User/Register';
import {LanguageSwitch} from './LanguageSwitch/LanguageSwitch';
import {DownloadFormControler} from './Downloads/DownloadForm';
import {JobApplicationController} from './JobApplication/JobApplication';
import {DirectlyDownloadFileOnProductPage} from './Downloads/DirectlyDownloadFileOnProductPage';
import {CheckConsentForVimeoDownload} from './Utility/Usercentrics';
import {polyfillForIe} from './Functions/Utilities';
import {RegionController} from './LanguageOverlay/RegionController';

domReady(() => {
  polyfillForIe();
  Sentry.init({dsn: 'https://9cb14c5bc45143ffaf95d83f3a442345@sentry.integration02.andersundsehr.com/25'});
  injectTagManager();
  detectBrowser();
  mailDecryption();
  new RegionController();
  new Modal();
  new FormValidator();
  new FilterJobsController();
  new CookieBar();
  new SearchSuggest();
  new LoginController();
  new RegisterController();
  new LanguageSwitch();
  new JobApplicationController();
  new DirectlyDownloadFileOnProductPage();
  new FormController();

  const searchResults = document.querySelector('.js-resultpage');
  if (searchResults) {
    new SearchResultPage(searchResults);
  }

  const productDetailPage = document.querySelector('.js-productPage');
  if (productDetailPage) {
    new DownloadFormControler();
  }

  const multiSelectItems = document.querySelectorAll('.js-webform-details-toggle');
  if (multiSelectItems.length) {
    new MultiSelect('.form-select');
  }

  if (document.querySelector('.event-detailed')) {
    import(/* webpackChunkName: "EventMapController" */ './Event/EventMap').then(module => {
      new module.EventMapController();
    });
  }

  if (document.querySelector('.js-slnr-downloads')) {
    import(/* webpackChunkName: "DownloadCenterController" */ './Downloads/DownloadCenter').then(module => {
      new module.DownloadCenterController();
    });
  }

  if (document.querySelector('.tx-slnr-partner')) {
    import(/* webpackChunkName: "HelpMapController" */ './Partner/HelpSalesMap').then(module => {
      new module.HelpSalesMap();
    });
    const map = document.querySelector('#map-zh');
    if (map) {
      import(/* webpackChunkName: "PartnerBingMapController" */ './Partner/BingMap/PartnerChina').then(module => {
        new module.PartnerChinaController();
      });
    } else {
      import(/* webpackChunkName: "PartnerGoogleMapController" */ './Partner/Partner').then(module => {
        new module.PartnerController();
      });
    }
  }


  if (document.querySelector('.js-product-usercentrics')) {
    CheckConsentForVimeoDownload();
  }

  if (document.querySelector('.js-websiteSurvey')) {
    import(/* webpackChunkName: "WebsiteSurvey" */ './WebsiteSurvey/WebsiteSurvey').then(module => {
      new module.WebsiteSurvey();
    });
  }
});
